/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cart-header[_ngcontent-%COMP%]{font-size:12px;text-transform:uppercase;color:#ccc;letter-spacing:.1px}.cart-footer[_ngcontent-%COMP%]{margin-bottom:30px;padding-top:5px}.total-price[_ngcontent-%COMP%]{font-weight:700;font-size:15px;text-transform:uppercase}.uom-values[_ngcontent-%COMP%]{color:#ccc;font-size:15px}@media (max-width:467px){.th-productdetails[_ngcontent-%COMP%]{-webkit-box-flex:100%;flex:100%;max-width:100%}.th-quantity[_ngcontent-%COMP%]{display:none}}"];
export { styles as styles };
